import React from "react";
import i18n from "i18next";

import { legendItemStyle, legendStyle } from "./style";
import { natcatSelectionText, natcatEuroText } from "./LegendUtils";

export const climateIndexLevelNames = () => [
  i18n.t("levels.veryLow"),
  i18n.t("levels.relativelyLow"),
  i18n.t("levels.relativelyModerate"),
  i18n.t("levels.relativelyHigh"),
  i18n.t("levels.veryHigh"),
];

export const InlandFloodIspraTIVLegend = ({
  title,
  indexValues,
  colorValues = ["#F7FBFF", "#C8DCF0", "#73B2D8", "#2979B9", "#08306B"],
  areaUnit,
  dataFrom,
  riskRangeFrom,
  riskRangeTo,
}) => (
  <div style={{ ...legendStyle }}>
    <div style={{ width: "250px" }}>
      <b>{title}</b>
    </div>
    <div>
      <span style={legendItemStyle(colorValues[0])}></span>
      {climateIndexLevelNames()[1]}:index &lt; {indexValues[1]}
    </div>
    <div>
      <span style={legendItemStyle(colorValues[1])}></span>
      {climateIndexLevelNames()[1]}: {indexValues[1]} &le; index &lt; {indexValues[2]}
    </div>
    <div>
      <span style={legendItemStyle(colorValues[2])}></span>
      {climateIndexLevelNames()[2]}: {indexValues[2]} &le; index &lt; {indexValues[3]}
    </div>
    <div>
      <span style={legendItemStyle(colorValues[3])}></span>
      {climateIndexLevelNames()[3]}: {indexValues[3]} &le; index &le; {indexValues[4]}
    </div>
    <div>
      <span style={legendItemStyle(colorValues[4])}></span>
      {climateIndexLevelNames()[4]}: index &ge; {indexValues[4]}
    </div>

    <div>
      <span
        style={{
          marginTop: 10,
          display: "block",
          float: "left",
          width: "250px",
          lineHeight: 1,
        }}
      >
        {`${natcatSelectionText}. The "index" in this legend is the total insured value
(TIV) (given in millions of ${natcatEuroText}) of properties with locations that have their inland flood risk level
from ${riskRangeFrom} to ${riskRangeTo}. The value is computed per ${areaUnit}. `}
        {`© CyStellar. The data from ${dataFrom} processed by CyStellar`}
      </span>
    </div>
  </div>
);
